import React, { useState, useEffect } from 'react';
import Settings from '../assets/images/settings.png';
import Help from '../assets/images/help.png';
import Avatar from '../assets/images/profile.png';
import { Link } from 'react-router-dom';
import { LuCircleHelp } from "react-icons/lu";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { BsThreeDots } from "react-icons/bs";
import { LuSettings } from "react-icons/lu";
import { useHistory } from "react-router-dom";

import { logOut } from "../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";
import { useDispatch } from 'react-redux';
import { toggleChatbot } from '../store/actions/chatbotActions';
import { getProfile } from "../store/actions/profileActions";
import {getRisks} from "../store/actions/riskActions";
import SearchBar from "../components/searchBar";
import { PiRabbit } from "react-icons/pi";

const DropdownMenu = ({ logOutFN, firstName, lastName, avatar }) => {



    return (
        <div className="absolute right-4 top-12 w-48 bg-white rounded-md border border-gray-300 rounded-[5px] shadow-lg z-10 dropdown-menu">
            <div className="flex items-center cursor-pointer p-2 border-b border-gray-300 mr-2 ml-2">
                <img src={avatar || Avatar} alt="Avatar" className="w-8 h-8 rounded-full mr-2" />
                <span className="text-black text-sm">{firstName} {lastName}</span>
            </div>

            <div className="p-2">  
                <div className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black border-b border-gray-300 mt-[-4px]">
                    <i className="fas fa-user"></i>
                    <span className="ml-2 text-sm"><Link to="/profile">Edit Profile</Link></span>
                </div>
                <div className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black" onClick={() => logOutFN()}>
                    <i className="fas fa-sign-out-alt"></i>
                    <span className="ml-2 text-sm">Logout</span>
                </div>
            </div>

        </div>
    );
};

const BsThreeDotsDropdown = ({ isOpen, toggleDropdown }) => {
    return (
        <div className="relative">
            <div className="hover:bg-white hover:bg-opacity-50 hover:rounded p-2 cursor-pointer text-white " onClick={toggleDropdown}>
                <BsThreeDots/>
            </div>
            {isOpen && (
                <div className="absolute right-[-40px] top-8 w-32 bg-white rounded-md border border-gray-300 rounded-[5px] shadow-lg z-10 dropdown-menu">
                    <Link to="/help" className="flex text-sm items-center space-x-2 p-2 hover:bg-gray-100 border-b border-gray-300 ml-2 mr-2">
                        <LuCircleHelp className="w-4 h-4 text-black" />
                        <span className="text-black">Help</span>
                    </Link>
                    <Link to="/settings" className="flex text-sm items-center space-x-2 p-2 hover:bg-gray-100 ml-2 mr-2">
                        <LuSettings className="w-4 h-4 text-black "/>
                        <span className="text-black">Settings</span>
                    </Link>
                </div>
            )}
        </div>
    );
};

const ProfileIcon = ({ toggleDropdown, firstName, lastName, avatar }) => {
    return (
        // <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#3b3b3b] text-white text-[0.6em] font-bold cursor-pointer dropdown-menu" onClick={toggleDropdown}>
        //     {firstName ? firstName.charAt(0) : ""}
        //     {lastName ? lastName.charAt(0) : ""}
        // </div>
        <div className="flex items-center space-x-2 cursor-pointer dropdown-menu hover:bg-white hover:bg-opacity-50 hover:rounded-full pl-2"  onClick={toggleDropdown}>
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#FFFFFF] text-white text-[0.6em] font-bold">
                
                <img src={avatar || Avatar} alt="Avatar" className="w-8 h-8 rounded-full" />
            </div>
        </div>
    );
};





const TopBar = ({ logOutFN, getProfileFN, profile }) => {
    useEffect(() => {
        getProfileFN();
    }, [getProfileFN]);

    const dispatch = useDispatch();

    const routerHistory = useHistory();
    const firstName = profile?.first_name || "";
    const lastName = profile?.last_name || "";
    const avatar = profile?.avatar || Avatar;

    const [isOpen, setIsOpen] = useState(false);
    const [isThreeDotsDropdownOpen, setThreeDotsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen((prev) => {
            if (isThreeDotsDropdownOpen) setThreeDotsDropdownOpen(false);
            return !prev;
        });
    };

    const toggleThreeDotsDropdown = () => {
        setThreeDotsDropdownOpen((prev) => {
            if (isOpen) setIsOpen(false);
            return !prev;
        });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.dropdown-menu')) {
                setIsOpen(false);
                setThreeDotsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (

        <header className="bg-[#3b3b3b] text-blue1 flex justify-between items-center p-4 border-b border-b-1 border-gray-300 shadow-sm"> 
      
            <h1 className="m-0 text-2xl font-bold text-[#FFFFFF]">Rabo</h1>



             <div className="flex items-center space-x-2">
        <HiChevronLeft
          onClick={() => routerHistory.goBack()}
          size={24}
          className="cursor-pointer text-white hover:text-white"
        />
        <HiChevronRight
          onClick={() => routerHistory.goForward()}
          size={24}
          className="cursor-pointer text-white hover:text-white"
        />
      
            <div className="relative">
                    <SearchBar
                        profile = {profile}
                    />
                </div>
            </div>

            <div className="flex space-x-4 mr-4">

                {/* <Link to="/help"><MdHelp alt="Help" className="w-6 h-6 text-[#3b3b3b]" /></Link>
                <Link to="/settings"><img src={Settings} alt="Settings" className="w-6 h-6" /></Link>
                <ProfileIcon toggleDropdown={toggleDropdown} firstName={firstName} lastName={lastName} /> */}
                {/* <BsThreeDots className="mt-2"/> */}
                
                <div className="">
                    <BsThreeDotsDropdown
                        isOpen={isThreeDotsDropdownOpen}
                        toggleDropdown={toggleThreeDotsDropdown}
                    />
                </div>
                <div className="flex items-center space-x-4">
                    
                    <ProfileIcon toggleDropdown={toggleDropdown} firstName={firstName} lastName={lastName} avatar={avatar} />
                </div>
                <button onClick={() => dispatch(toggleChatbot())}>
                    <PiRabbit className="w-6 h-6 text-white hover:text-blue-400" />
                </button>
            </div>
            {isOpen && <DropdownMenu logOutFN={logOutFN} firstName={firstName} lastName={lastName} avatar={avatar} />}
        </header>
    );
};

const mapStateToProps = (state) => {
    return {


        profile: state.profile.profile,
        


    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        logOutFN: () => dispatch(logOut()),
        getProfileFN: () => dispatch(getProfile()),
        getRisksFN: (currentPage, pageSize, department_id, sortBy) => dispatch(getRisks(currentPage, pageSize, department_id, sortBy)),

    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(TopBar);



